import React__default, { useMemo, useCallback } from 'react';
import ReactDatePicker from 'react-datepicker';
import { appService } from '../../../Hooks/Contexts.js';
import useConfig from '../../../Hooks/useConfig.js';
import { CustomDateDisplay } from './CustomDateDisplay.js';
import { DateWithKeyboardSupport } from './DateWithKeyboardSupport.js';

const getCalendarStartDay = (configuration, lang) => {
    const weekStartsOn = configuration.calendar?.weekStartsOn || {};
    return weekStartsOn[lang] ?? weekStartsOn[lang.substring(2)] ?? weekStartsOn?.en ?? 1;
};
const ReactDatePickerRenderer = (props) => {
    const { reactDatePickerRef, dataTestId, locale, customCalendarContainer, renderCustomHeader, onChange, onCalendarClose, onCalendarOpen, customInput, placeholderText, showInModal, withKeyboardSupport, toggleDropdown, date, displayFormat, theme, className, onInputChange, minDate, maxDate, inputClassName, useFormValidation, setValueToNullWhenFormatIsIncorrect, focusSelectedMonth, inline, noDatePickerOverflow, onMonthChange, withHeader, renderDayContents, noInitialValueInput } = props;
    const config = useConfig();
    const popperModifiers = useMemo(() => [
        {
            name: 'flip',
            options: {
                flipVariations: false,
                allowedAutoPlacements: ['bottom']
            },
            fn: () => {
                return new Promise(resolve => {
                    resolve({});
                });
            }
        },
        ...(noDatePickerOverflow
            ? [
                {
                    name: 'preventOverflow',
                    options: {
                        rootBoundary: 'viewport'
                    },
                    fn: () => {
                        return new Promise(resolve => {
                            resolve({});
                        });
                    }
                }
            ]
            : [])
    ], [noDatePickerOverflow]);
    const handleChange = useCallback((dates, event) => {
        if (showInModal) {
            if (Array.isArray(dates)) {
                if (dates.every(element => element)) {
                    if (toggleDropdown) {
                        toggleDropdown();
                    }
                }
            }
        }
        if (!!onChange) {
            onChange(dates, event);
        }
    }, [onChange, showInModal, toggleDropdown]);
    return (React__default.createElement(ReactDatePicker, { ...props, selectsRange: props.selectsRange, ref: reactDatePickerRef, "data-testid": dataTestId, locale: locale, calendarContainer: customCalendarContainer, renderCustomHeader: withHeader ? renderCustomHeader : undefined, renderDayContents: renderDayContents, onChange: handleChange, onCalendarOpen: onCalendarOpen, onCalendarClose: onCalendarClose, customInput: (customInput ||
            (withKeyboardSupport && (React__default.createElement(DateWithKeyboardSupport, { date: date, format: displayFormat, theme: theme, dataTestId: dataTestId, placeholder: placeholderText || '', className: className, onInputChange: onInputChange, minDate: minDate, maxDate: maxDate, inputClassName: inputClassName, useFormValidation: useFormValidation, setValueToNullWhenFormatIsIncorrect: setValueToNullWhenFormatIsIncorrect, noInitialValueInput: noInitialValueInput }))) ||
            ((date || placeholderText) && (React__default.createElement(CustomDateDisplay, { date: date, format: displayFormat, theme: theme, dataTestId: dataTestId, placeholder: placeholderText || '', className: className })))), placeholderText: placeholderText, selected: date, popperPlacement: "bottom-start", focusSelectedMonth: focusSelectedMonth, popperClassName: "iso__date-picker__popper", popperModifiers: popperModifiers, minDate: minDate, maxDate: maxDate, calendarStartDay: getCalendarStartDay(config, appService.lang || config.defaultLanguage), onMonthChange: onMonthChange, inline: inline }));
};

export { ReactDatePickerRenderer as default };
//# sourceMappingURL=ReactDatePickerRenderer.js.map
